import Head from "next/head";

const AsiaCupFAQSchema = () => {
  return (
    <Head>
      <script
        id="FAQPageSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
                {
                  "@type": "Question",
                  "name": "कब से शुरू होगा एशिया कप 2025?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "टी20 एशिया कप 2025 की शुरुआत 9 सितंबर से होगी."
                  }
                },
                {
                  "@type": "Question",
                  "name": "एशिया कप में भारत बनाम पाकिस्तान का मैच कब होगा?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "भारत और पाकिस्तान का हाई-वोल्टेज मुकाबला 14 सितंबर को खेला जाएगा."
                  }
                },
                {
                  "@type": "Question",
                  "name": "पिछली बार एशिया कप (टी20) का खिताब किसने जीता था?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "साल 2022 में श्रीलंका ने एशिया कप टी20 का खिताब जीता था."
                  }
                },
                {
                  "@type": "Question",
                  "name": "एशिया कप टी20 इतिहास में सबसे ज्यादा विकेट किस गेंदबाज ने लिए हैं?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "भुवनेश्वर कुमार के नाम एशिया कप टी20 में सबसे ज्यादा 13 विकेट लेने का रिकॉर्ड है."
                  }
                },
                {
                  "@type": "Question",
                  "name": "एशिया कप टी20 इतिहास में सबसे ज्यादा रन किस बल्लेबाज ने बनाए हैं?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "एशिया कप टी20 में  विराट कोहली ने सबसे ज्यादा 429 रन बनाए हैं जिसमें 4 अर्धशतक शामिल है."
                  }
                },
                {
                  "@type": "Question",
                  "name": "टी20 एशिया कप में अब तक का सबसे बड़ा स्कोर किस टीम ने बनाया है?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "भारत ने 2022 में अफगानिस्तान के खिलाफ 212/2 रन बनाकर एशिया कप टी20 का सबसे बड़ा स्कोर बनाया था."
                  }
                },
                {
                  "@type": "Question",
                  "name": "एशिया कप 2025 में सुपर-4 के लिए क्वालिफिकेशन का नियम क्या है?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "हर ग्रुप से टॉप-2 टीमें सुपर-4 में जगह बनाएंगी."
                  }
                },
                {
                  "@type": "Question",
                  "name": "एशिया कप 2025 में कुल कितनी टीमें हिस्सा ले रही हैं?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "इस बार एशिया कप 2025 में कुल 8 टीमें हिस्सा ले रही हैं."
                  }
                },
                  {
                  "@type": "Question",
                  "name": "एशिया कप 2025 मैचों की लाइव स्ट्रीमिंग कहां देखी जा सकती है?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "एशिया कप 2025 का लाइव प्रसारण सोनी स्पोर्ट्स नेटवर्क पर होगा और इसकी लाइव स्ट्रीमिंग SonyLIV ऐप व वेबसाइट पर देखी जा सकती है"
                  }
                },
                {
                  "@type": "Question",
                  "name": "एशिया कप 2025 का फाइनल मैच कहां खेला जाएगा?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "एशिया कप 2025 का फाइनल मुकाबला दुबई इंटरनेशनल स्टेडियम में खेला जाएगा।"
                  }
                },
                 {
                  "@type": "Question",
                  "name": "भारत ने अब तक कितनी बार एशिया कप (टी20) का खिताब जीता है?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "भारत ने अब तक केवल 1 बार एशिया कप टी20 का खिताब जीता है."
                  }
                },
                {
                  "@type": "Question",
                  "name": "एशिया कप 2025 में भारत का उप-कप्तान कौन होगा?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "शुभमन गिल एशिया कप 2025 में भारतीय टीम के उप- कप्तान होंगे."
                  }
                }
              ],
          }),
        }}
      />
    </Head>
  );
};

export default AsiaCupFAQSchema;
